import { useEffect, useState } from "react";
import { WEDDING } from "@/data/wedding";

const compute = () => {
  const diff = new Date(WEDDING.dateISO).getTime() - Date.now();
  if (diff <= 0) return null;
  return {
    jours: Math.floor(diff / 86400000),
    heures: Math.floor(diff / 3600000) % 24,
    minutes: Math.floor(diff / 60000) % 60,
    secondes: Math.floor(diff / 1000) % 60,
  };
};

const ITEMS = [
  { key: "jours", label: "Jours", testid: "countdown-jours" },
  { key: "heures", label: "Heures", testid: "countdown-heures" },
  { key: "minutes", label: "Minutes", testid: "countdown-minutes" },
  { key: "secondes", label: "Secondes", testid: "countdown-secondes" },
];

export default function Countdown() {
  const [t, setT] = useState(compute);

  useEffect(() => {
    const id = setInterval(() => setT(compute()), 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <div data-testid="countdown" className="max-w-md">
      {t === null && (
        <p className="mb-3 font-serif text-xl italic text-terracotta">
          Le grand jour est arrivé !
        </p>
      )}
      <div className="grid grid-cols-4 gap-3 sm:gap-4">
        {ITEMS.map(({ key, label, testid }) => (
          <div
            key={key}
            data-testid={testid}
            className="rounded-2xl border border-line bg-paper px-1 py-4 text-center shadow-[0_10px_30px_rgba(44,38,35,0.05)]"
          >
            <div className="font-mono text-2xl tabular-nums text-ink sm:text-3xl">
              {t ? String(t[key]).padStart(2, "0") : "00"}
            </div>
            <div className="mt-1.5 font-mono text-[9px] uppercase tracking-[0.2em] text-fog sm:text-[10px]">
              {label}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
